import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import config from "../../Config";
import TemplateRegistry from "./components/ResumeTemplates/TemplateRegistry";
import { ResumeTemplateTypes } from "./components/ResumeTemplates/ResumeTemplateTypes";
import Footer from "../Footer";
import { useLanguage } from "../../i18n";

function Resume() {
    const [templateType, setTemplateType] = useState(null);
    const { t } = useLanguage();

    useEffect(() => {
        // Set the template type based on configuration
        setTemplateType(config.templateType);
    }, []);

    // Function to render the appropriate template
    const renderTemplate = () => {
        // Retrieve the template component from the registry
        const TemplateComponent = TemplateRegistry[templateType] || TemplateRegistry[ResumeTemplateTypes.STANDARD];
        return <TemplateComponent config={config} />;
    };

    return (
        <div className="min-h-screen bg-gray-50 print:bg-transparent print:min-h-0">
            {/* Navigation */}
            <div className="bg-white border-b border-gray-200 print:hidden">
                <div className="max-w-6xl mx-auto px-5 py-4">
                    <Link 
                        to="/" 
                        className="inline-flex items-center text-gray-600 hover:text-gray-900 transition-colors"
                    >
                        <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                        </svg>
                        {t('blog.backToHome')}
                    </Link>
                </div>
            </div>

            {/* Resume Content */}
            {renderTemplate()}
            
            <div className="print:hidden">
                <Footer/>
            </div>
        </div>
    );
}

export default Resume;
